(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PurchaseReturnOrderEditController', PurchaseReturnOrderEditController);

    PurchaseReturnOrderEditController.$inject = ['$scope','$state', '$q', 'MessageService', 'DateUtils', 'PurchaseProductLine', 'Supplier', 'Depository', 'PurchaseOrderReturn', 'Product', 'PurchaseOrder', 'entity','$uibModal', '$localStorage','$http'];

    function PurchaseReturnOrderEditController ($scope, $state, $q, MessageService, DateUtils, PurchaseProductLine, Supplier, Depository, PurchaseOrderReturn, Product, PurchaseOrder, entity,$uibModal, $localStorage, $http) {
        var vm = this;
        vm.productDelete = productDelete;
        vm.deletedList = []
        vm.token = $localStorage.authenticationToken;

        vm.purchaseOrder = entity;
        // vm.suppliers = Supplier.getAll();
        vm.update = true;
        $q.all([vm.purchaseOrder.$promise]).then(function(){
            if(vm.purchaseOrder.status != 'New'){
                vm.update = false;
            }
            // init();
        });

        function init() {
            if(vm.purchaseOrder.type =='Outsourcing'){
                vm.warehousis = Depository.getAll({type: 'product'});
            }else if(vm.purchaseOrder.type =='RawMaterial'){
                vm.warehousis = Depository.getAll({type: "accessories"});
            }else{
                vm.warehousis = Depository.getAll({type: null});
            }

            vm.deliveryDate = vm.purchaseOrder.deliveryDate == null ? null : vm.purchaseOrder.deliveryDate.substr(0, 10);
            // $q.all([vm.warehousis.$promise]).then(function(){
            //     getProduct(function (){
            //         if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
            //             // 为了选择sku时的优化  将已删除的商品单拿出来  避免污染正在选择的商品及sku
            //             var _tempList = []
            //             vm.purchaseOrder.purchaseProductLines.forEach(function(itm){
            //                 if(itm.cancelled){
            //                     vm.deletedList.push(itm)
            //                 }else{
            //                     _tempList.push(itm)
            //                 }
            //             })
            //             vm.purchaseOrder.purchaseProductLines = _tempList

            //             var _ids = []
            //             vm.purchaseOrder.purchaseProductLines.forEach(function (line){
            //                 if(vm.purchaseOrder.status == 'AlreadyIssued' && !line.warehousingNum){
            //                     line.warehousingNum = line.num;
            //                 }
            //                 $scope.selectPurchaseProduct(line)
            //                 if(!line.propertyConfigId && line.propertyConfigSku && line.propertyConfigs && line.propertyConfigs.length>0){
            //                     for(var i=0; i<line.propertyConfigs.length; i++){
            //                         if(line.propertyConfigSku == line.propertyConfigs[i].sku){
            //                             line.propertyConfigId=line.propertyConfigs[i].id;
            //                             _ids.push(line.propertyConfigs[i].id)
            //                             break
            //                         }
            //                     }
            //                 }
            //             })
            //             setOptions(_ids)
            //         }
            //     })
            // });
        }

        function productDelete(record,index) {
            var _data = JSON.parse(JSON.stringify(vm.purchaseOrder.returnLines))
            if(_data[index].id){
                _data[index].cancelled = true;
                vm.deletedList.push(_data[index])
                _data.splice(index, 1);
            }else{
                _data.splice(index, 1);
            }
            vm.purchaseOrder.returnLines = _data
        }



        function getDate(strDate) {
            var st = strDate;
            var a = st.split(" ");
            var b = a[0].split("-");
            var c = a[1].split(":");
            var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2]);
            return date;
        }

        $scope.save = function(saveAndSubmit,callback){
            if(vm.isSaving){return }
            // if (!vm.purchaseOrder.supplierId) {
            //     MessageService.error("请选择供应商");
            //     return false;
            // }
            // if (vm.purchaseOrder.type == null || vm.purchaseOrder.type == '') {
            //     MessageService.error("请选择退货类型");
            //     return false;
            // }

            // var deliveryDate = getDate($('#startDate').val() + " 23:59:59");
            // vm.purchaseOrder.deliveryDate = deliveryDate;
            // if (vm.purchaseOrder.deliveryDate == null || vm.purchaseOrder.deliveryDate == '') {
            //     MessageService.error("请选择计划交期");
            //     return false;
            // }
            // if (!vm.purchaseOrder.warehouseId) {
            //     MessageService.error("请选择默认入库");
            //     return false;
            // }
            if (vm.purchaseOrder.contact == null || vm.purchaseOrder.contact == '') {
                MessageService.error("请输入联系人");
                return false;
            }
            if (vm.purchaseOrder.phone == null || vm.purchaseOrder.phone == '') {
                MessageService.error("请输入联系电话");
                return false;
            }
            if (vm.purchaseOrder.address == null || vm.purchaseOrder.address == '') {
                MessageService.error("请输入收货地址");
                return false;
            }
            if (vm.purchaseOrder.freight === null || vm.purchaseOrder.freight === '' || vm.purchaseOrder.freight < 0) {
                MessageService.error("请输入运费");
                return false;
            }
            if(vm.purchaseOrder.returnLines && vm.purchaseOrder.returnLines.length>0){
                var returnLines = [];
                vm.deletedList.forEach(function(delItem){
                    vm.purchaseOrder.returnLines.push(delItem)
                })
                var flag =  true
                vm.purchaseOrder.returnLines.forEach(function (item){
                    if(flag){
                        if(!item.cancelled){
                            returnLines.push(item)
                        }
                        if(item.num > item.returnableNum){
                            flag = false
                            MessageService.error(item.productName + " 退货数量不得超过可退数量");
                            return false;
                        }
                        if(item.price > item.purchaseLinePrice){
                            flag = false
                            MessageService.error(item.productName + " 退货单价不得超过采购单价");
                            return false;
                        }
                    }
                })
                if(!flag)return
                if (returnLines.length == 0) {
                    MessageService.error("退货商品信息不能为空");
                    return false;
                }
                for (var i = 0; i < vm.purchaseOrder.returnLines.length; i++) {
                    var purchaseProductLine = vm.purchaseOrder.returnLines[i];
                    if(!purchaseProductLine.cancelled){
                        if (purchaseProductLine.num == null || purchaseProductLine.num < 0) {
                            MessageService.error("请输入商品信息中的数量");
                            return false;
                        }
                        if (purchaseProductLine.price == null) {
                            MessageService.error("请输入商品信息中的单价");
                            return false;
                        }

                        if (purchaseProductLine.tax === null || purchaseProductLine.tax === '' || purchaseProductLine.tax < 0) {
                            MessageService.error("请输入商品信息中的税率");
                            return false;
                        }
                        vm.purchaseOrder.returnLines[i].total = (purchaseProductLine.num * purchaseProductLine.price).toFixed(2);
                        vm.purchaseOrder.returnLines[i].taxPrice = ((purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price).toFixed(4);
                        vm.purchaseOrder.returnLines[i].taxTotal = vm.purchaseOrder.returnLines[i].taxPrice * purchaseProductLine.num;
                    }
                }

            }else {
                MessageService.error("退货商品信息不能为空");
                return false;
            }

            vm.isSaving = true;
            if(saveAndSubmit){
                PurchaseOrderReturn.saveAndSubmit(vm.purchaseOrder, function(res){
                    vm.isSaving = false;
                    MessageService.success('提交退货成功！');
                    $scope.cancelSave();
                },function(error){
                    vm.isSaving = false;
                    MessageService.error('新建退货失败');
                });
            }else{
                if(vm.purchaseOrder.status == 'AlreadyIssued'){
                    PurchaseOrderReturn.changeWarehousingNum(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        MessageService.success('保存成功！');
                        $scope.cancelSave();
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('编辑退货失败');
                    });
                    return
                }
                if(vm.purchaseOrder.id){
                    PurchaseOrderReturn.update(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        if(callback){
                            callback()
                        }else{
                            MessageService.success('编辑退货成功！');
                            $scope.cancelSave();
                        }
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('编辑退货失败');
                    });
                }else{
                    PurchaseOrderReturn.save(vm.purchaseOrder, function(res){
                        vm.isSaving = false;
                        if(callback){
                            callback()
                        }else{
                            MessageService.success('新建退货成功！');
                            $scope.cancelSave();
                        }
                    },function(error){
                        vm.isSaving = false;
                        MessageService.error('新建退货失败');
                    });
                }
            }
        };

        //导出
        $scope.export = function () {
            $http({
                url: 'api/purchase-order-returns/exportDetail/'+vm.purchaseOrder.id,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "退货单"+ vm.purchaseOrder.number + '_' +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        $scope.cancelSave = function() {
            history.back();
        }

        $scope.getSupplier = function() {
            vm.purchaseOrder.supplierName = null;
            vm.taxRate = 0;
            if(vm.purchaseOrder.supplierId){
                vm.suppliers.forEach(function (item){
                    if(item.id == vm.purchaseOrder.supplierId){
                        vm.purchaseOrder.supplierName =item.name;
                        vm.taxRate = item.taxRate;
                    }
                })
            }
            if(vm.purchaseOrder.purchaseProductLines && vm.purchaseOrder.purchaseProductLines.length>0){
                vm.purchaseOrder.purchaseProductLines.forEach(function (item){
                    item.tax = vm.taxRate;
                })
            }
        }
        //通过或拒绝
        $scope.audit = function (item){
            if(!item){
                MessageService.confirm("是否审核拒绝", function () {
                    PurchaseOrderReturn.reject({id:vm.purchaseOrder.id}, function(res){
                        if(res.state == 400){
                            MessageService.error(res.message || '拒绝失败');
                            return
                        }
                        MessageService.success('已拒绝');
                        $scope.cancelSave();
                    },function(error){
                        MessageService.error(error.data.message || '拒绝失败');
                    });
                });
            }else{
                var flag1 =  true
                vm.purchaseOrder.returnLines.forEach(function (item){
                    if(flag1){
                        if(item.returnableNum <= 0){
                            flag1 = false
                            MessageService.error(item.productName + "可退数量为0,无法通过");
                            return false;
                        }
                    }
                })
                if (flag1){
                    MessageService.confirm("确认审核通过", function () {
                        PurchaseOrderReturn.approve({id:vm.purchaseOrder.id}, function(res){
                            if(res.state == 400){
                                MessageService.error(res.message || '通过失败');
                                return
                            }
                            MessageService.success('已通过');
                            $scope.cancelSave();
                        },function(error){
                            MessageService.error(error.data.message || '通过失败');
                        });
                    });
                }
            }
        }
        //关闭
        $scope.close = function (){
            MessageService.confirm("确认关闭当前退货单", function () {
                PurchaseOrderReturn.close({id:vm.purchaseOrder.id}, function(res){
                    if(res.state == 400){
                        MessageService.error(res.message || '关闭失败');
                        return
                    }
                    MessageService.success('已关闭');
                    $scope.cancelSave();
                },function(error){
                    MessageService.error('关闭失败');
                });
            });
        }
        $scope.numChange = function (purchaseProductLine){
            purchaseProductLine.warehousingNum = purchaseProductLine.num;
            $scope.currentItemChange(purchaseProductLine)
        }
        $scope.currentItemChange = function (purchaseProductLine){
            // 限制用户只能输入两位小数
            if(purchaseProductLine.price){
                var value = purchaseProductLine.price;
                var regex = /^(\d+(\.\d{0,4})?)$/;
                if (!regex.test(value)) {
                    var parts = String(value).split('.')
                    if (parts[1].length > 4) {
                        value = parts[0] + '.' + parts[1].substring(0, 4);
                    }
                    purchaseProductLine.price = Number(value)
                }
            }
            purchaseProductLine.taxPrice = ((purchaseProductLine.price * purchaseProductLine.tax / 100) + purchaseProductLine.price).toFixed(4)
            purchaseProductLine.taxTotal = purchaseProductLine.taxPrice * purchaseProductLine.num
        }
        $scope.purchaseOrderType = function (item){
            switch (item) {
                case 'New':
                    return {
                        text:'待提交',
                        color:'#333'
                    };
                case 'ToBeAudited':
                    return {
                        text:'待审核',
                        color:'#ffa037'
                    };
                case 'ToBeRevised':
                    return {
                        text:'已关闭',
                        color:'#333'
                    };
                case 'AlreadyIssued':
                    return {
                        text:'未入库',
                        color:'#ff0000'
                    };
                case 'Store':
                    return {
                        text:'部分入库',
                        color:'#51de37'
                    };
                case 'Finished':
                    return {
                        text:'已完成',
                        color:'#005eff'
                    };
                case 'Examined':
                    return {
                        text:'审核通过',
                        color:'#333'
                    };
                default:
                    return {
                        text:item,
                        color:'#333'
                    };
            }
        }
    }
})();
